// Fetch all App Version
import axios from "axios";
import {
  FETCH_COMPLAINTS_DATA,
  ADD_COMPLAINT_SELECTION,
  REMOVE_COMPLAINT_SELECTION,
  CLEAR_ALL_COMPLAINT_DATA,
  GET_PRODUCT_LIST,
  GET_PRODUCT_PROBLEM_LIST,
  GET_COMPLAINT_BUCKET,
  GET_COMPLAINT_STATUS,
  EDIT_COMPLAINTS_DATA,
  GET_COMPLAINTS_DETAIL,
  CALL_CUSTOMER,
  GET_RPU_COURIER,
  ADD_STATUS_ID,
  SHOW_COMPLAINT_DETAILS,
  GET_CITY_LIST,
  REFRESH_COMPLAINT_LIST,
  GET_STATE_LIST,
  FETCH_COMPLAINTS_COUNT,
  FETCH_COMMENTS,
  FETCH_CONVERSATIONS,
  FETCH_HISTORY,
  FETCH_INSURANCE,
  FETCH_PAGINATION_INFO,
  TRACK_STATUS_DATA,
  SCREENING_RESPONSE,
  PRINT_LABEL_DATA,
  TRANSFER_TO_DD,
  RESEND_MAIL,
  FETCH_CANNED_REPONSES,
  RESCHEDULE_IVR,
  FETCH_REFUND_EDIT,
  FETCH_GENERATE_LINK,
  GET_CHANNEL_LIST,
  FETCH__GC_AAPPROVED_LINK,
  FETCH_REUND_CASE,
  FETCH_ADMIN_LIST,
  FETCH_GC_CASE,
  FETCH_GCAPPROVAL_CASE,
  FETCH_REFUNDAPPROVAL_CASE,
  FETCH_DOWNLOAD_REPORT,
  FETCH_REFUND_RESEND,
  FETCH_GC_APPROVAL_CASE,
  GET_SUB_PROBLEM_LIST,
  FETCH_CONVERSATIONS_DATA,
  COSMOS_RES,
  FETCH_CONVERSATIONS_LOAD,
  FETCH_COMMENT_DATA,
  FETCH_COMMENT_LOAD,
  SET_BUCKET_ID_LIST,
  SET_ACTION_TRUE,
  SAVE_MAC_ID,
  GET_NON_NFA,
  GET_FAULTS_LIST,
  JIRA_TICKET_SUCCESS,
  JIRA_TICKET_ERROR,
  FETCH_TICKET_CLOSURE_REASONS
} from "./types";
import { baseUrl, webBaseUrl, oldUrl, newBackendBaseUrl } from "../config";
import { gqlQuery, productGetCompat } from "./gqlClient";
import history from "../history";

export const rescheduleIVR = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/schedule-ivr", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: RESCHEDULE_IVR,
          payload: res.data,
        });
      }
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const sendEmail = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/send-customer-mail", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type : PRINT_LABEL_DATA,
        //   payload : res.data.data
        // })
        alert("Successfully done");
      } else {
        alert("Something went wrong");
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const submitFreshDeskClick = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/freshdesk-move", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type : PRINT_LABEL_DATA,
        //   payload : res.data.data
        // })
        alert("Successfully done");
      }
      else {
        alert(res.data.message);
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const regenerateCoupons = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(baseUrl + "/complaint/regenerate-coupon", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type : PRINT_LABEL_DATA,
        //   payload : res.data.data
        // })
        alert("Successfully done");
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      if (e.response.status === 429) {
        alert(e.response.statusText || "Something went wrong");
      }
    });
};

export const qcSubmit = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/testing", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type : PRINT_LABEL_DATA,
        //   payload : res.data.data
        // })
        alert("Successfully done");
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const repairPaymentSubmit = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/repair-payment", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type : PRINT_LABEL_DATA,
        //   payload : res.data.data
        // })
        alert("Successfully done");
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      if (e.response.status === 429) {
        alert(e.response.statusText || "Something went wrong");
      }
    });
};

export const handleRequestPaymentSubmit = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/fd-request-payment", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type : PRINT_LABEL_DATA,
        //   payload : res.data.data
        // })
        alert("Successfully done");
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const fetchPrintLabel = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/printLabel", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: PRINT_LABEL_DATA,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: PRINT_LABEL_DATA,
          payload: null,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const returnPolicyAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/return_policy", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        alert("Successfully sent");
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      if (e.response.status === 429) {
        alert(e.response.statusText || "Something went wrong");
      }
    });
};

export const fetchTrackStatus = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  let url = "";
  if (data.tracking === "shiprocket") {
    url = baseUrl + "/courier/shiprocket/track-awb";
  } else {
    url = baseUrl + "/courier/clickpost/track-awb";
  }
  return await axios
    .post(url, data, { headers: { "x-access-token": token } })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: TRACK_STATUS_DATA,
          payload: res.data.data,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const forwardPickupCancel = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/forward-cancel", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "Successfully Cancelled." : "Cancellation failed!"));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const reversePickupCancel = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/forward-cancel", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "Successfully Cancelled." : "Cancellation failed!"));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const moveToRtoCase = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/rto-case", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "Successfully Moved." : "Couldn't move."));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const transferTodirectDispatch = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/direct-dispatch", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data?.success) {
        dispatch({
          type: TRANSFER_TO_DD,
          payload: res.data,
        });
      }
      alert(res.data?.message || (res.data?.success ? "Successfully Dispatched." : "Dispatch failed!"));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const transferTodirectDispatchFreshdesk = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/direct-dispatch", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: TRANSFER_TO_DD,
          payload: res.data,
        });
        // history.push('/complaints-data')
        // window.location.reload()
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const moveToDispatchInward = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/dispatch-inward", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // history.push('/complaints-data')
        // window.location.reload()
        alert(res.data.message);
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

// submitRPU
let isSubmittingRPU = false;

export const submitRPU = (data) => async (dispatch) => {
  if (isSubmittingRPU) return; // ignore duplicate clicks

  isSubmittingRPU = true;

  let token = localStorage.getItem("token");

  return axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/reverse-pickup", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        alert("Successfully sent");
      } else {
        alert(res.data.message);
      }
    })
    .catch((e) => {
      // debugger;
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
      if (e.response?.status === 401) {
        history.push("/");
      }
    })
    .finally(() => {
      isSubmittingRPU = false; // unlock after request ends
    });
};


export const unmarkedTicketRefund = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/refund-unmark", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        alert(res.data.message);
      } else {
        alert(res.data.message);
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      // history.push('/')
    });
};

export const unmarkedTicketGC = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/gc-unmark", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        alert(res.data.message);
      } else {
        alert(res.data.message);
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      // history.push('/')
    });
};

export const revokeTicket = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/complaint/revoke/" + data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "Successfully Revoked." : "Couldn't revoke."));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const clearComplaintData = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ALL_COMPLAINT_DATA,
  });
};

export const addComplaintSelection = (data) => async (dispatch) => {
  dispatch({
    type: ADD_COMPLAINT_SELECTION,
    payload: data,
  });
};

export const removeComplaintSelection = () => async (dispatch) => {
  dispatch({
    type: REMOVE_COMPLAINT_SELECTION,
  });
};

export const getRefundData = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  // let token = "abc"
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/list", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: FETCH_COMPLAINTS_DATA,
          payload: res.data.data.complaint_data || [],
        });
        dispatch({
          type: FETCH_COMPLAINTS_COUNT,
          payload: res.data || [],
        });
        dispatch({
          type: FETCH_PAGINATION_INFO,
          payload: res.data.data || [],
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getComplaintData = (data, boseFlag = false) => async (dispatch) => {
  let token = localStorage.getItem("token");
  // let token = "abc"
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/list", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        debugger;
        dispatch({
          type: FETCH_COMPLAINTS_DATA,
          payload: res.data.data.complaint_data,
        });
        dispatch({
          type: FETCH_COMPLAINTS_COUNT,
          payload: res.data || [],
        });
        dispatch({
          type: FETCH_PAGINATION_INFO,
          payload: res.data.data || [],
        });
      } else {
        dispatch({
          type: FETCH_COMPLAINTS_DATA,
          payload: res.data,
        });
        dispatch({
          type: FETCH_COMPLAINTS_COUNT,
          payload: [],
        });
        dispatch({
          type: FETCH_PAGINATION_INFO,
          payload: [],
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const moveToTestingInward = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/testing-inward", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "Successfully Moved." : "Couldn't move."));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const moveToTestingOutward = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/testing-outward", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "Successfully Moved." : "Couldn't move."));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const regeneratePaymentLink = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/regenerate-payment", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type: FETCH_COMPLAINTS_DATA,
        //   payload: res.data.data.complaint_data || []
        // })
        alert("Successfully Moved");
        // window.location.reload()
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const submitScreenName = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/screening", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type: FETCH_COMPLAINTS_DATA,
        //   payload: res.data.data.complaint_data || []
        // })
        // alert("Successfully Moved")
        // window.location.reload()
        dispatch({
          type: SCREENING_RESPONSE,
          payload: res.data.data,
        });
      }
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const callbackTagSubmit = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/callback-tagging", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type: FETCH_COMPLAINTS_DATA,
        //   payload: res.data.data.complaint_data || []
        // })
        alert("Successfully Moved");
        // window.location.reload()
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getComplaintBuckets = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  dispatch({
    type: GET_COMPLAINT_BUCKET,
    payload: [],
  });
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/bucket/list", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_COMPLAINT_BUCKET,
          payload: res.data.data,
        });
        // dispatch({
        //   type: ADD_STATUS_ID,
        //   payload: res.data.data[0].id
        // })
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getComplaintStatus = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/status", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_COMPLAINT_STATUS,
          payload: res.data,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getProductList = (data) => async (dispatch) => {
  // Replaces legacy /product/get with the GraphQL productColorSearch query.
  try {
    const payload = await productGetCompat(data);
    dispatch({
      type: GET_PRODUCT_LIST,
      payload,
    });
    return payload;
  } catch (e) {
    console.error("Error fetching product list:", e);
  }
};

export const getAllNonNfa = () => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(
      newBackendBaseUrl + "/connect-complaint/v1/complaint/fetch-all-non-nfa",
      {},
      { headers: { "x-access-token": token } }
    )
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_NON_NFA,
          payload: res.data,
        });
        return res.data;
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getProductProblemList = (data) => async (dispatch) => {
  // Maps the old `/product/problem-list` { category_id } body onto the GraphQL
  // `problems` query. The payload is reshaped to { problems: [...] } so consumers
  // that read `problemData.problems` keep working unchanged.
  const variables = {};
  if (data && data.category_id !== undefined && data.category_id !== null && data.category_id !== "") {
    variables.categoryId = Number(data.category_id);
  }
  return await gqlQuery(
    `query ($categoryId: Int) {
      problems(filter: { categoryId: $categoryId }) {
        id
        problem
        product_group_id
        category_name
        is_sub
        is_eol
      }
    }`,
    variables
  )
    .then((res) => {
      dispatch({
        type: GET_PRODUCT_PROBLEM_LIST,
        payload: { problems: res.problems },
      });
    })
    .catch((e) => {
      console.error("Error fetching problem list:", e);
    });
};

export const getSubProblemList = (data) => async (dispatch) => {
  // Old `/product/sub-problem-list` accepted { problem_id } as either an array or
  // a single value; normalise to the Int array the GraphQL `subProblems` query needs.
  const problemIds =
    data && data.problem_id != null
      ? (Array.isArray(data.problem_id) ? data.problem_id : [data.problem_id]).map(Number)
      : [];
  return await gqlQuery(
    `query ($problemIds: [Int!]) {
      subProblems(filter: { problemIds: $problemIds }) {
        id
        sub_problem
        product_problem_id
        is_show_app_deeplink
      }
    }`,
    { problemIds }
  )
    .then((res) => {
      dispatch({
        type: GET_SUB_PROBLEM_LIST,
        payload: { sub_problems: res.subProblems },
      });
    })
    .catch((e) => {
      dispatch({
        type: GET_SUB_PROBLEM_LIST,
        payload: [],
      });
    });
};

export const editComplaintData = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/edit", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: EDIT_COMPLAINTS_DATA,
        payload: res.data,
      });
      alert(res.data?.message || (res.data?.success ? "Updated successfully." : "Update failed."));
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const addComments = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/add-comment", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        // dispatch({
        //   type: ADD_COMMENT,
        //   payload: res.data
        // })
        dispatch({
          type: FETCH_CONVERSATIONS,
          payload: res.data,
        });
        return res.data;
        // dispatch(refreshComplaintList(true))
        // dispatch(showComplaintDetailsAction(false))
      }
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      if (e.response.status === 429) {
        alert(e.response.statusText || "Something went wrong");
      }
    });
};

export const sendMail = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/msg-customer", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: FETCH_CONVERSATIONS,
          payload: res.data.data.conversation,
        });
        return res.data;
      }
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      if (e.response.status === 429) {
        alert(e.response.statusText || "Something went wrong");
      }
    });
};

export const getComplaintDetail = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/details/" + data, {}, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_COMPLAINTS_DETAIL,
          payload: res.data.data[0] || null,
          error: null,
        });
        dispatch({
          type: FETCH_COMMENTS,
          payload: res.data.data[0] ? res.data.data[0].comments : [],
        });
        dispatch({
          type: FETCH_CONVERSATIONS,
          payload: res.data.data[0] ? res.data.data[0].conversation : [],
        });
      } else {
        dispatch({
          type: GET_COMPLAINTS_DETAIL,
          payload: null,
          error: res.data.errors?.message || res.data.message || null,
        });
      }
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      dispatch({
        type: GET_COMPLAINTS_DETAIL,
        payload: null,
        error:
          e.response?.data?.errors?.message ||
          e.response?.data?.message ||
          e.message ||
          null,
      });
    });
};

export const callCustomer = (customerId, complaintId) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/customer/call/" + customerId + "/" + complaintId, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data.message);
      if (res.data.success) {
        dispatch({
          type: CALL_CUSTOMER,
          payload: res.data,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getRpuCourier = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(baseUrl + "/courier/get-pincode", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_RPU_COURIER,
          payload: res.data.data,
        });
        // dispatch({
        //   type : COURIER_ID,
        //   payload : res.data.data[0] ? res.data.data[0].courier_id : null
        // })
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const addStatusId = (data) => async (dispatch) => {
  dispatch({
    type: ADD_STATUS_ID,
    payload: Number(data),
  });
};

export const showComplaintDetailsAction = (flag) => async (dispatch) => {
  dispatch({
    type: SHOW_COMPLAINT_DETAILS,
    payload: flag,
  });
};

export const refreshComplaintList = (flag) => async (dispatch) => {
  dispatch({
    type: REFRESH_COMPLAINT_LIST,
    payload: flag,
  });
};

export const getStateList = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-master/v1/master/state", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_STATE_LIST,
          payload: res.data,
        });
      } else {
        // Still dispatch empty list if success is false (optional)
        dispatch({
          type: GET_STATE_LIST,
          payload: [],
        });
      }

      return res; // Return for external usage
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
      }
    });
};

export const getFaultsList = (product_group_id) => async (dispatch) => {
  // Replaces legacy /product/get-faults/:id with the GraphQL faults query.
  // Returns { success, data: [...] } so consumers reading faultsDataList.success
  // and faultsDataList.data keep working unchanged.
  try {
    const result = await gqlQuery(
      `query ($productGroupId: Int!) {
        faults(productGroupId: $productGroupId) {
          id
          name
          product_group_id
          fault_type
        }
      }`,
      { productGroupId: Number(product_group_id) }
    );
    const payload = { success: true, data: result.faults };
    dispatch({
      type: GET_FAULTS_LIST,
      payload,
    });
    return payload;
  } catch (e) {
    console.error("Error fetching faults list:", e);
  }
};

export const getCityByState = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-master/v1/master/city", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_CITY_LIST,
          payload: res.data,
        });
      } else {
        dispatch({
          type: GET_CITY_LIST,
          payload: [],
        });
      }
      return res.data
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getChannelList = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/channel/list", data, {
      headers: {
        "x-access-token": token,
      },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_CHANNEL_LIST,
          payload: res.data,
        });
      }
      return res.data?.data;
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const sendCustomerInvoice = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/resend-invoice", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      // if (res.data.success) {
      dispatch({
        type: RESEND_MAIL,
        payload: res.data.message,
      });
      // }
    })
    .catch((e) => {
      history.push("/");
    });
};

export const cannedResponse = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-message/v1/getCannedMsg", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: FETCH_CANNED_REPONSES,
          payload: res.data.data,
        });
      } else {
        alert(res.data.message);
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      if (e.response.status === 429) {
        alert(e.response.statusText || "Something went wrong");
      }
    });
};

export const refundEdit = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/refund", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_REFUND_EDIT,
        payload: res.data.data,
      });
      // Migrated backend returns per-ticket reasons; surface them instead of a blind success.
      const failed = Array.isArray(res.data.failureTicket) ? res.data.failureTicket : [];
      if (failed.length) {
        const lines = failed
          .map((f) => (f && typeof f === "object" ? `${f.ticket_id}: ${f.reason}` : `${f}`))
          .join("\n");
        alert(`${res.data.message || "Refund update"}\n\nFailed:\n${lines}`);
      } else {
        alert(res.data.message);
      }
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      } else {
        const msg =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          "Refund request failed. Please try again.";
        alert(msg);
      }
    });
};

export const generateLink = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/re-refund", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_GENERATE_LINK,
        payload: res.data.data,
      });
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) history.push("/");
    });
};

export const GCApproval = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/gc-approve", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH__GC_AAPPROVED_LINK,
        payload: res.data,
      });
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) history.push("/");
    });
};

export const resendReund = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(baseUrl + "/complaint/resend-gc", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_REFUND_RESEND,
        payload: res.data,
      });
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) history.push("/");
    });
};

export const refundCaseApproval = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/refund-case", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_REUND_CASE,
        payload: res.data,
      });
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) history.push("/");
    });
};

export const adminList = () => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-master/v1/users/cs", { headers: { "x-access-token": token } })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: FETCH_ADMIN_LIST,
          payload: res.data,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const gcCase = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/gc-case", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_GC_CASE,
        payload: res.data,
      });
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) history.push("/");
    });
};

export const gcApprovalSubmit = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/gc-approval", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_GCAPPROVAL_CASE,
        payload: res.data,
      });
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) history.push("/");
    });
};

export const refundApprovalSubmit = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/refund-approval", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_REFUNDAPPROVAL_CASE,
        payload: res.data,
      });
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) history.push("/");
    });
};

export const downlodReport = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(baseUrl + "/record/refund-report", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        alert(res.data.message);
        dispatch({
          type: FETCH_DOWNLOAD_REPORT,
          payload: res.data,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 400) {
        alert(e.response.data.message);
      } else if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const moveToReadyToDispatch = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(baseUrl + "/complaint/ready-to-dispatch", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "Successfully moved to ready to dispatch." : "Failed."));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const cosmosAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/add-cosmos", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data.message);
      dispatch({
        type: COSMOS_RES,
        payload: res.data,
      });
    })
    .catch((e) => {
      if (e.response.status === 400) {
        alert(e.response.data.message);
      } else if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getConversationData = (id, page) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/complaint/get-conversation/" + id + "?page=" + page, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_CONVERSATIONS_DATA,
        payload: res.data.data.conversation,
      });
      dispatch({
        type: FETCH_CONVERSATIONS_LOAD,
        payload: res.data.data,
      });
      return res.data.data.conversation;
    })
    .catch((e) => {
      if (e.response.status === 400) {
        alert(e.response.data.message);
      } else if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getHistoryData = (id, page = 1) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/complaint/get-history/" + id + "?page=" + page, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_HISTORY,
        payload: res.data.data.history,
      });
      return res.data.data.history;
    })
    .catch((e) => {
      if (e.response?.status === 400) {
        alert(e.response.data.message);
      } else if (e.response?.status === 401) {
        history.push("/");
      }
    });
};

// NAS-6091: fetch live SYMBO claim status for the Insurance tab. `refresh` bypasses the 5-min
// backend cache. Dispatches FETCH_INSURANCE (merged onto complaintsDetail.insurance) and also
// returns the payload so the component can drive its own loading/error state.
export const getInsuranceClaim = (id, refresh = false) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/complaint/insurance/" + id + (refresh ? "?refresh=1" : ""), {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_INSURANCE,
        payload: res.data.data,
      });
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 400) {
        alert(e.response.data.message);
      } else if (e.response?.status === 401) {
        history.push("/");
      }
      return { success: false, message: e.response?.data?.message };
    });
};

export const flagAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/flag-complaint", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 400) {
        alert(e.response.data.message);
      } else if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getCommentData = (id, page) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/complaint/get-comments/" + id + "?page=" + page, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_COMMENT_DATA,
        payload: res.data.data.comments,
      });
      dispatch({
        type: FETCH_COMMENT_LOAD,
        payload: res.data.data,
      });
      return res.data.data.comments;
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getSCConversationData = (id, page) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/complaint/get-comments/" + id + "?page=" + page, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_COMMENT_DATA,
        payload: res.data.data.comments,
      });
      dispatch({
        type: FETCH_COMMENT_LOAD,
        payload: res.data.data,
      });
      return res.data.data.comments;
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const addBucketID = (data) => async (dispatch) => {
  dispatch({
    type: SET_BUCKET_ID_LIST,
    payload: data,
  });
};

export const setACtionTrue = (data) => async (dispatch) => {
  dispatch({
    type: SET_ACTION_TRUE,
    payload: data,
  });
};

export const saveMACID = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/add-new-mac", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: SAVE_MAC_ID,
        payload: res.data,
      });
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const oosTestingAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/oos/testing-inward", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || "Done.");
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const getScProductList = (data) => async (dispatch) => {
  // Replaces legacy /product/get_service_center_products with the GraphQL
  // productColors query (full enriched product x color catalogue). Returns
  // { products: [...] } so the caller's data.products keeps working.
  try {
    const result = await gqlQuery(
      `query {
        productColors(filter: {}) {
          id
          product_id
          product_name
          color_id
          color_name
          product_group_id
          group_name
        }
      }`,
      {}
    );
    return { products: result.productColors };
  } catch (e) {
    console.error("Error fetching SC product list:", e);
  }
};

export const getScProblemList = (data) => async (dispatch) => {
  // Replaces legacy /product/get_all_problem_list with the GraphQL problemsWithSubProblems
  // query. Returns { products: [...] } so the caller's `data.products` keeps working.
  try {
    const result = await gqlQuery(
      `query ($productGroupId: Int) {
        problemsWithSubProblems(productGroupId: $productGroupId) {
          problem_id
          problem
          sub_problem_id
          sub_problem
        }
      }`,
      data && data.group_id != null ? { productGroupId: Number(data.group_id) } : {}
    );
    return { products: result.problemsWithSubProblems };
  } catch (e) {
    console.error("Error fetching SC problem list:", e);
  }
};

export const getInvoiceDetails = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    // .post("http://127.0.0.1:3006/connect" + "-complaint/v1/complaint/extract/invoice-details", data, {
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/extract/invoice-details", data, {

      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      } else {
        const message = e.response?.data?.errors?.message || e.response?.data?.message || "Error fetching invoice details. Please try again.";
        throw new Error(message);
      }
    });
};

export const createJiraTicket = (ticketId) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/connect/jira-integration", { id: ticketId }, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: JIRA_TICKET_SUCCESS,
        payload: res.data
      });
      alert(res.data.message);
      return res.data;
    })
    .catch((e) => {
      dispatch({
        type: JIRA_TICKET_ERROR,
        payload: e.response?.data || 'Error creating Jira ticket'
      });
      if (e.response?.status === 401) {
        history.push("/");
      }
    });
};

export const getReplacementDetails = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/complaint/get/replacement/mac-id", {
      headers: { "x-access-token": token },
      params: data,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      } else {
        const message = e.response?.data?.errors?.message || e.response?.data?.message || "Error fetching replacement details. Please try again.";
        throw new Error(message);
      }
    });
};

// Resolves a Connect customer to their NoiseFit app user id(s) via the complaint backend, which
// in turn asks the central user-detail service. Returns the response so the caller can render it
// (like getReplacementDetails) instead of alert()-ing and dispatching.
export const getAppUserId = (customerId) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(newBackendBaseUrl + "/connect-complaint/v1/customer/app-user-id/" + customerId, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      } else {
        const message = e.response?.data?.errors?.message || e.response?.data?.message || "Error fetching app user id. Please try again.";
        throw new Error(message);
      }
    });
};

export const logisticPaymentAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/logistic-payment", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "Logistic payment link sent successfully." : "Failed to send logistic payment link."));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const rpuPaymentRefundAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/rpu-payment-refund", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      } else {
        const message = e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.";
        throw new Error(message);
      }
    });
};

export const updateWaterSeepageAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint//water-seepage", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || "Marked as Water Seepage successfully.");
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const updateReqcAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/action/reqc", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || "Moved to REQC successfully.");
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const updateReqcToTestingInward = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/action/reqc/testingInward", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || "Moved to Testing Inward successfully.");
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const rpuPaymentDoneAction = (data) => async (dispatch) => {
    let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/rpu-payment-done", data, {
       headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      } else {
        const message = e.response?.data?.errors?.message || e.response?.data?.message || "Error Pease try again.";
        throw new Error(message);
      }
    });
};

export const rpuPaymentAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/rpu-payment", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data?.message || (res.data?.success ? "RPU payment link sent successfully." : "Failed to send RPU payment link."));
      return res.data;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        history.push("/");
        return;
      }
      alert(e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.");
    });
};

export const cancelPaymentAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/cancel-payment", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      } else {
        const message = e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.";
        throw new Error(message);
      }
    });
};

export const getPaymentHistoryAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/payment-history", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      } else {
        const message = e.response?.data?.errors?.message || e.response?.data?.message || "Error. Please try again.";
        throw new Error(message);
      }
    });
};

export const fetchTicketClosureReasons = (type = "CS") => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(`${newBackendBaseUrl}/connect-complaint/v1/ticket-closure-reason/list?type=${type}`, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      const list = res.data && res.data.success ? res.data.data : [];
      dispatch({
        type: FETCH_TICKET_CLOSURE_REASONS,
        payload: list,
      });
      return list;
    })
    .catch((e) => {
      if (e.response && e.response.status === 401) {
        history.push("/");
      }
      return [];
    });
};